var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { PureComponent } from "react";
import { Redirect } from "react-router";
import { Link } from "react-router-dom";
import AvisoForm from "../shared/form/form";
import ResourceForm from "./resourceForm";
import AvisoAlert from "../shared/alert";
import AvisoSpinner from "../shared/loading";
import AvisoLayout from "../shared/layout";
import AvisoDiv from "../shared/div";
import { getXSRF } from "../../src/Services/Shared/FetchService";
const resourceTypeOptions = [
    { id: 1, description: "Use content from the Editor below" },
    { id: 2, description: "Use content from a Url" },
];
class ResourceEdit extends PureComponent {
    constructor(props) {
        super(props);
        this.setSettingsTabActive = (val) => {
            this.setState((prevState) => {
                return Object.assign(Object.assign({}, prevState), { settingsTabActive: val });
            });
        };
        this.fetchResource = this.fetchResource.bind(this);
        this.renderNav = this.renderNav.bind(this);
        this.onError = this.onError.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.state = {
            loading: false,
            // @ts-expect-error - TS2322 - Type '{ loading: false; data: null; links: never[]; saved: false; resourceId: null; errorMessage: string; canManage: false; resourceName: string; settingsTabActive: true; }' is not assignable to type 'State'.
            data: null,
            links: [],
            saved: false,
            resourceId: null,
            errorMessage: "",
            canManage: false,
            resourceName: "",
            settingsTabActive: true,
        };
        const { resourceId } = props.match.params;
        this.fetchResource(resourceId);
    }
    onError() {
        this.setState({ errorMessage: "Please fill out all required fields below." }, () => window.scroll(0, 0));
    }
    onSubmit(formData, e) {
        return __awaiter(this, void 0, void 0, function* () {
            console.log(formData);
            const { categoryId, resourceId } = this.props.match.params;
            const response = yield fetch("/aviso/resourceGuide/saveResource", {
                method: "POST",
                body: JSON.stringify(Object.assign({ resourceId, categoryId }, formData)),
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-XSRF-TOKEN": getXSRF(),
                },
            });
            const result = yield response.json();
            if (result.success) {
                if (result && result.data && result.data.id) {
                    this.setState({ saved: true, resourceId: result.data.id });
                }
                else {
                    this.setState({
                        errorMessage: "There may have been an error saving this resource. Please verify the resource was updated.",
                    });
                    window.scroll(0, 0);
                }
            }
            else {
                this.setState({
                    saved: false,
                    errorMessage: "There was an error saving this resource. Please try again.",
                });
            }
        });
    }
    fetchResource(resourceId) {
        return __awaiter(this, void 0, void 0, function* () {
            const { categoryId } = this.props.match.params;
            let url = `/aviso/resourceGuide/getResource?cid=${categoryId}`;
            if (resourceId) {
                url += `&id=${resourceId}`;
            }
            const response = yield fetch(url, {
                method: "GET",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
            });
            const result = yield response.json();
            const { resource, category, canManage, isUser } = result.data;
            this.setState({ resourceName: resource.name });
            if (!isUser) {
                // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'Location'.
                window.location = window.location.href.replace("category", "categoryAuth");
            }
            let links = [
                { anchor: "Categories", link: "/aviso/app/resourceGuide/index" },
                {
                    link: `/aviso/app/resourceGuide/category/${category.id}`,
                    anchor: category.name,
                },
            ];
            if (resourceId) {
                links = [
                    ...links,
                    {
                        link: `/aviso/app/resourceGuide/category/${category.id}/resource/${resourceId}/details`,
                        anchor: result.name,
                    },
                    { link: "", anchor: "Edit" },
                ];
            }
            else {
                links.push({ link: "", anchor: "Create" });
            }
            const form = [];
            const formData = yield ResourceForm.getResourceForm();
            if (formData.length < 1) {
                const state = Object.assign(Object.assign({}, this.state), { loading: false, errorMessage: "Failed to load form." });
                this.setState(state);
            }
            formData.forEach((it) => {
                // @ts-expect-error - TS7034 - Variable 'row' implicitly has type 'any[]' in some locations where its type cannot be determined.
                const row = [];
                it.forEach((x) => {
                    let val = "";
                    if (x.property === "displayInternalResource") {
                        // Populates form data because displayInternalResource is a boolean.
                        // If the boolean is null (creating a new resource) or if it is true
                        // we display the internal resource.
                        if (resource[x.property] === null || resource[x.property]) {
                            // @ts-expect-error - TS2322 - Type '{ id: number; description: string; }' is not assignable to type 'string'.
                            val = resourceTypeOptions[0];
                        }
                        else {
                            // @ts-expect-error - TS2322 - Type '{ id: number; description: string; }' is not assignable to type 'string'.
                            val = resourceTypeOptions[1];
                        }
                    }
                    else {
                        val = resource[x.property];
                    }
                    // const val = resource[x.property];
                    row.push(Object.assign(Object.assign({}, x), { value: val }));
                });
                // @ts-expect-error - TS7005 - Variable 'row' implicitly has an 'any[]' type.
                form.push(row);
            });
            const state = Object.assign(Object.assign({}, this.state), { form, loading: false, links,
                canManage });
            this.setState(state);
        });
    }
    renderError(error) {
        if (error) {
            return _jsx("div", { className: "alert alert-danger", children: error });
        }
        return null;
    }
    renderNav() {
        const { categoryId, resourceId } = this.props.match.params;
        return (_jsxs("span", { children: [_jsx(AvisoDiv, { show: !!resourceId, children: _jsxs(Link, { className: "btn btn-link", title: "Back to Resource", to: `/aviso/app/resourceGuide/category/${categoryId}/resource/${resourceId}/details`, children: [_jsx("span", { className: "fa fa-arrow-left mr-1" }), "Back", _jsx("span", { className: "sr-only", children: "Back to Resource" })] }) }), _jsx(AvisoDiv, { show: !resourceId, children: _jsxs(Link, { className: "btn btn-link", title: "Back to Resource List", to: `/aviso/app/resourceGuide/category/${categoryId}`, children: [_jsx("span", { className: "fa fa-arrow-left mr-1" }), "Back", _jsx("span", { className: "sr-only", children: "Back to Resource List" })] }) })] }));
    }
    render() {
        const { resourceId } = this.props.match.params;
        if (this.state.saved && this.state.resourceId) {
            const { categoryId } = this.props.match.params;
            return (_jsx(Redirect, { to: `/aviso/app/resourceGuide/category/${categoryId}/resource/${this.state.resourceId}/details` }));
        }
        if (this.state.saved && this.state.resourceId) {
            this.renderError(this.state.errorMessage);
        }
        if (this.state.loading || !this.state.form) {
            return _jsx(AvisoSpinner, { isLoading: true });
        }
        if (!this.state.canManage) {
            return this.renderError("You do not have permission to manage resources. Please contact your system admin for permission.");
        }
        return (_jsx(AvisoLayout, { renderNav: this.renderNav, children: _jsxs("div", { children: [_jsxs("h1", { children: [resourceId ? "Edit " : "New ", "Resource"] }), _jsxs("div", { children: [_jsx(AvisoAlert, { message: this.state.errorMessage, show: !!this.state.errorMessage, type: "danger" }), _jsx("div", { className: "mb-3", children: _jsxs("ul", { className: "nav nav-pills nav-link-underline", role: "tablist", children: [_jsx("li", { className: "nav-item", role: "presentation", children: _jsx("button", { className: "btn btn-link nav-link " +
                                                    (this.state.settingsTabActive ? " active" : ""), onClick: () => this.setSettingsTabActive(true), id: "settings-tab", role: "tab", "aria-controls": "settings-tab", "aria-selected": this.state.settingsTabActive, children: "Settings" }) }), _jsx("li", { className: "nav-item" +
                                                (!this.state.settingsTabActive ? " active" : ""), role: "presentation", children: _jsx("button", { className: "btn btn-link nav-link " +
                                                    (!this.state.settingsTabActive ? " active" : ""), onClick: () => this.setSettingsTabActive(false), id: "content-tab", role: "tab", "aria-controls": "content-tab", "aria-selected": !this.state.settingsTabActive, children: "Content" }) })] }) }), _jsx("div", { role: "tabpanel", children: _jsx(AvisoForm, { form: this.state.form, onError: this.onError, onSubmit: this.onSubmit, currentTab: this.state.settingsTabActive ? 1 : 2, cancelLink: resourceId
                                        ? `/aviso/app/resourceGuide/category/${this.props.match.params.categoryId}/resource/${resourceId}/details`
                                        : `/aviso/app/resourceGuide/category/${this.props.match.params.categoryId}` }) })] })] }) }));
    }
}
export default ResourceEdit;
